// Decimal formatting never routes authoritative amounts through floating point.
/* global BigInt */
import { PAYMENT_ERROR_COPY } from './paymentErrors';
export const decimal = value => {
  if (value == null || !/^-?\d+(\.\d{1,2})?$/.test(String(value))) return null;
  const [whole, fraction = ''] = String(value).split('.');
  return `${whole}.${fraction.padEnd(2, '0')}`;
};
export const money = value => {
  const formatted = decimal(value);
  if (formatted == null) return '—';
  const [whole, fraction] = formatted.split('.');
  return `AED ${whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}.${fraction}`;
};
export const positiveAmount = value => /^\d+(\.\d{1,2})?$/.test(String(value)) && /[1-9]/.test(String(value));
export const amountCents = value => { const text = decimal(value); return text == null ? null : BigInt(text.replace('.', '')); };
export const halfAmount = value => {
  const cents = amountCents(value); if (cents == null || cents < 0n) return null;
  const half = (cents + 1n) / 2n; return `${half / 100n}.${String(half % 100n).padStart(2, '0')}`;
};
export const label = value => String(value || 'Not available').replaceAll('_', ' ').replace(/\b\w/g, c => c.toUpperCase());
export const capability = (projection, key) => projection?.capabilities?.[key] || { allowed: false, reason: 'Not available' };
export const actionReason = action => action?.reason || PAYMENT_ERROR_COPY[action?.reason_code] || ({ ROW_STATE_BLOCKED: 'Not available in this state', QUERY_MUTATION_DENIED: 'This query is not editable by you', RESOURCE_SCOPE_DENIED: 'Not available for these records', ACTOR_REQUIRED: 'Original reporter required' }[action?.reason_code]) || label(action?.reason_code);
